// client/src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import BrandsLogin from './pages/Brands/BrandsLogin';
import BrandDashboard from './pages/Brands/BrandDashboard';
import AdminLogin from './pages/Admin/Login';
import AdminLayout from './pages/Admin/Layout';
import BrandsList from './pages/Admin/BrandsList';
import BrandRegister from './pages/Admin/BrandRegistration';
import CustomerHistory from './pages/History/CustomerHistory';

function App() {
  return (
    <Router>
      <Routes>
        {/* Brand Routes - Default at root */}
        <Route path="/" element={<BrandsLogin />} />
        <Route path="/brand-login" element={<BrandsLogin />} />
        <Route path="/brand-dashboard" element={<BrandDashboard />} />
        <Route path="/customer-history" element={<CustomerHistory />} />

        {/* Admin Routes */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-dhobicart" element={<AdminLayout />}>
          <Route
            index
            element={<Navigate to="/admin-dhobicart/brands" replace />}
          />
          <Route path="brands" element={<BrandsList />} />
          <Route path="brands/register" element={<BrandRegister />} />
          <Route path="brands/edit/:id" element={<BrandRegister />} />
        </Route>

        {/* Catch all - redirect to brand login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;